import {
    selectDoc, selectArr,
    observeAdd,
    event, addClass, removeClass, removeClassAll, isVisible
} from "../utils/utils";

import {initSlider} from "../helpers/service.slider";
import {formatMoney} from "../helpers/service.cart";
import {Modal} from "./component.modal";

const props = {
    html: selectDoc('html'),
    form: selectDoc('#concierge-page .main-form'),
    fixedContainer: selectDoc('#fixed-bar'),
    btnsForm: selectArr('.btn.btn-form'),
    showModalCount: 0,
    currentModal: null,
}

const rangeSlider = (id, onDrag) => {
    var range = document.getElementById(id),
        dragger = range.children[0],
        draggerWidth = 24, // width of your dragger
        down = false,
        rangeWidth, rangeLeft;

    dragger.style.width = draggerWidth + 'px';
    dragger.style.left = -(draggerWidth/2) + 'px';
    dragger.style.marginLeft = (0 / 2) + 'px';

    range.addEventListener("mousedown", function(e) {
        rangeWidth = this.offsetWidth;
        rangeLeft = ((window.innerWidth - rangeWidth) / 2) + this.offsetLeft;
        down = true;
        updateDragger(e);
        return false;
    });

    document.addEventListener("mousemove", function(e) {
        updateDragger(e);
    });

    document.addEventListener("mouseup", function() {
        down = false;
    });

    function updateDragger(e) {
        if (down &&
            e.pageX >= rangeLeft &&
            e.pageX <= (rangeLeft + rangeWidth)) {
            dragger.style.left = e.pageX - rangeLeft - (draggerWidth/2) + 'px';
            if (typeof onDrag == "function") onDrag(Math.round(((e.pageX - rangeLeft) / rangeWidth) * 100));
        }
    }
}

const initializer = () => {
    if (props.form) {
        let sliderReady = false;
        observeAdd(props.form, function (nodes) {
            if (!sliderReady) {
                sliderReady = true;
                initSlider('#experience-steps-slider', {
                    perView: 1,
                    type: 'slider',
                    gap: 0,
                    peek: {
                        before: 0,
                        after: 0
                    }
                });

                initSlider('#reviews-slider', {
                    perView: 1,
                    type: 'slider',
                    gap: 0,
                    peek: {
                        before: 0,
                        after: 0
                    }
                });

                /**
                 * Form custom js
                 */
                selectArr('#concierge-page .main-form [type="file"]').map(fileInput => {
                    event(fileInput, 'change', function (event) {
                        let file = event.target.files[0],
                            reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = function (e) {
                            let label = selectDoc('label', fileInput.parentNode)
                            if(label) {
                                let fileName = selectDoc('span.filename', label)
                                if(fileName) {
                                    fileName.innerHTML = `${file.name.length > 20 ? file.name.slice(0, 20) + '...' : file.name}`
                                } else {
                                    label.innerHTML += `<span class="filename">${file.name.length > 20 ? file.name.slice(0, 20) + '...' : file.name}</span>`
                                }
                            }
                        }.bind(this);
                    })
                });

                selectArr('#concierge-page .main-form [type="number"]').map((numberInput, index) => {
                    let slider = document.createElement('div')
                    slider.classList.add('range-slider');
                    slider.id = `range-slider-${index}`;
                    slider.innerHTML = '<span></span>';
                    numberInput.parentNode.appendChild(slider);

                    let ranges = selectDoc('.globo-description', numberInput.parentNode)
                    if(ranges) {
                        let rangesContainer = document.createElement('div')
                        rangesContainer.className = 'ranges-container'
                        ranges.innerHTML.split(',').map(range => {
                            rangesContainer.innerHTML += `<div>${range}</div>`
                        })
                        numberInput.parentNode.appendChild(rangesContainer);
                    }

                    rangeSlider(`range-slider-${index}`, function(value) {
                        let formattedValue = '';
                        switch (numberInput.getAttribute('name')) {
                            case "number": //Thousands
                                numberInput.value = value * 1000;
                                formattedValue = '$' + formatMoney(`${value * 1000}00`);
                                break;
                            case "number-2": //Carat
                                numberInput.value = (value / 100);
                                formattedValue = (numberInput.value + ' Ct.');
                                break;
                        }


                        let label = selectDoc('label', numberInput.parentNode)
                        if(label) {
                            let inputValue = selectDoc('span.inputvalue', label)
                            if(inputValue) {
                                inputValue.innerHTML = `${formattedValue}`
                            } else {
                                label.innerHTML += `<span class="inputvalue">${formattedValue}</span>`
                            }
                        }
                    });
                });

                /**
                 * Diamond
                 */
                let diamondClarity = selectDoc('.panels .panel:nth-child(3) .globo-form-control:nth-child(6) legend');
                if(diamondClarity) {
                    let tooltip = document.createElement('button')
                    tooltip.className = 'question-icon modal-open'
                    tooltip.setAttribute('data-m', 'clarity-modal')
                    diamondClarity.appendChild(tooltip);
                }

                /**
                 * Metal
                 */
                let metalPreference = selectDoc('.panels .panel:nth-child(3) .globo-form-control:nth-child(10) legend');
                if(metalPreference) {
                    let tooltip = document.createElement('button')
                    tooltip.className = 'question-icon modal-open'
                    tooltip.setAttribute('data-m', 'metal-modal')
                    metalPreference.appendChild(tooltip);
                }

                /**
                 * Other
                 */
                let metalOther = selectDoc('.panels .panel:nth-child(3) .globo-form-control:nth-child(11)'),
                    radiosContainer = selectDoc('.panels .panel:nth-child(3) .globo-form-control:nth-child(10)');
                if(metalOther && radiosContainer) {
                    event(radiosContainer, 'click', function () {
                        removeClass(metalOther, 'active')
                    })

                    event(metalOther, 'click', function () {
                        let input = selectDoc('input', metalOther),
                            radio = selectDoc('.panels .panel:nth-child(3) .globo-form-control:nth-child(10) ul li:last-child input');
                        if(input.getAttribute('disabled') !== null) {
                            radio ? radio.click() : ''
                            input.focus();
                            addClass(metalOther, 'active')
                        } else {
                            removeClass(metalOther, 'active')
                        }
                    })
                }

                let designOther = selectDoc('.panels .panel:nth-child(3) .globo-form-control:nth-child(3)'),
                    radiosContainerDesign = selectDoc('.panels .panel:nth-child(3) .globo-form-control:nth-child(2)');
                if(designOther && radiosContainerDesign) {
                    event(radiosContainerDesign, 'click', function () {
                        removeClass(designOther, 'active')
                    })

                    event(designOther, 'click', function () {
                        let input = selectDoc('input', designOther),
                            radio = selectDoc('.panels .panel:nth-child(3) .globo-form-control:nth-child(2) ul li:last-child input');
                        if(input.getAttribute('disabled') !== null) {
                            radio ? radio.click() : ''
                            input.focus();
                            addClass(designOther, 'active')
                        } else {
                            removeClass(designOther, 'active')
                        }
                    })
                }

                new Modal(false);
            }
        })

        let lastScrollTop = 0;
        event(window, 'scroll', function () {
            /**
             * Fixed bar
             */
            let st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop) {
                //Scroll down
                if (window.scrollY > 600) {
                    removeClass(props.fixedContainer, 'fixedUp')
                    addClass(props.fixedContainer, 'fixed')
                } else {
                    removeClass(props.fixedContainer, 'fixedUp')
                    removeClass(props.fixedContainer, 'fixed')
                }
            } else {
                //Scroll up
                if (window.scrollY > 600) {
                    removeClass(props.fixedContainer, 'fixed')
                    addClass(props.fixedContainer, 'fixedUp')
                } else {
                    removeClass(props.fixedContainer, 'fixedUp')
                    removeClass(props.fixedContainer, 'fixed')
                }
            }
            lastScrollTop = st <= 0 ? 0 : st;
        })

        props.btnsForm.map(btn => {
            event(btn, 'click', function () {
                props.form.scrollIntoView({
                    behavior: 'smooth'
                });
            })
        })
    }
}

export const Concierge = {
    init: () => initializer()
}
